'use strict'
/**
 * workoutAnalysis.js — Contrato CICATRIZ #2 (MACRO 1 · Ola 1).
 *
 * EL BUG QUE TIPA: el seed escribía en workout_analyses un analysis_json
 * sin workout.sport / workout.duration_min / glance.heroLine → HUB
 * renderizaba "Sesión · 0 min" como si fuera dato. El pipeline real
 * (analyzeWorkoutV2 → _bridgeNeopreneToUI) SÍ los puebla — verificado
 * con dump crudo (pádel 75min, sRPE 525, kb_refs foster_1998 etc.).
 *
 * PRODUCTOR: src/routes/hubRoutes.js · _bridgeNeopreneToUI() →
 *            POST /api/hub/:userId/analyze-workout → persistido en
 *            workout_analyses.analysis_json → GET latest-analysis
 * CONSUMIDOR: src/components/hub-v2/useHub.js → LastWorkoutCard
 */

const { z } = require('./z')

/** Cabecera de actividad — lo que LastWorkoutCard pinta (sport + duración). */
const WorkoutHeaderSchema = z
  .object({
    sport: z.string().min(1),
    activity_type: z.string().optional().nullable(),
    duration_min: z.number(),
    duration_seconds: z.number().optional().nullable(),
    source: z.string().optional().nullable(),
  })
  .passthrough()

/** Glance — el titular del análisis (heroLine es la promesa al usuario). */
const GlanceSchema = z
  .object({
    heroLine: z.string().min(1),
    trimp: z.number().nullable().optional(),
    effortKeyword: z.string().nullable().optional(),
    scoreContext: z.string().optional().nullable(),
  })
  .passthrough()

/**
 * El analysis_json persistido. workout + glance son el contrato duro
 * (lo que toca ojos de usuario); detail/reasoning/landed_reading viajan
 * con shape propio (LandedReading tiene su esquema aparte).
 */
const WorkoutAnalysisSchema = z
  .object({
    version: z.string().optional(),
    analyzed_at: z.string().optional().nullable(),
    workout: WorkoutHeaderSchema,
    glance: GlanceSchema,
  })
  .passthrough()

/** Respuesta de GET /api/hub/:userId/latest-analysis — analysis null = día-1 legítimo. */
const LatestAnalysisResponseSchema = z
  .object({
    analysis: WorkoutAnalysisSchema.nullable(),
  })
  .passthrough()

module.exports = {
  WorkoutHeaderSchema,
  GlanceSchema,
  WorkoutAnalysisSchema,
  LatestAnalysisResponseSchema,
}
